module.exports = __webpack_public_path__ + "img/peopleIcon.bdf57141.png";